import React from "react";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import CircularProgress from '@mui/material/CircularProgress';
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDButton from "../components/MDButton";
import Button from '../components/Button.jsx';

import Link from "@mui/material/Link";

function OthelloCard({ color, titulo, count, icono, iconofooter, footer, bigtitulo, searching, onClick, categoria, children, smallmode, smallfootermode, vermas })
{

    function renderfooter() {

        if (iconofooter == null && footer == null && onClick == null)
            return "";
        else

            return (<>
                <Divider />
                <MDBox pb={2} px={2}>
                    <MDTypography component="p" variant="button" color="text" display="flex">
                        {iconofooter != null ? <Icon fontSize="small" color="secondary">{iconofooter}</Icon> : ""}
                        {footer != null && footer != "" ? footer : ""}
                        {!searching && onClick != null ? <MDBox ml={1}><Icon fontSize="small" color="info" onClick={onClick}>info</Icon></MDBox> : ""}
                        {/*<MDTypography*/}
                        {/*    component="span"*/}
                        {/*    variant="button"*/}
                        {/*    fontWeight="bold"*/}
                        {/*    color={percentage.color}*/}
                        {/*>*/}

                        {/*    {percentage.amount}*/}
                        {/*</MDTypography>*/}
                        {/*&nbsp;{percentage.label}*/}
                        {/*&nbsp;{percentage.label}*/}
                    </MDTypography>
                </MDBox>
            </>);
    }

    let finalfooter = "";//renderfooter();

    let btvermas = vermas != null ? <MDBox pb={2} px={2}><Link href={vermas} color="inherit"><Button size="sm" color="info">Ver mas</Button></Link> </MDBox> : "";

    return (<MDBox pt={3} pr={2}>
            <Card >
                <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
                {icono != null && icono != "" ?
                    <MDBox
                        variant="gradient"
                        bgColor={color}
                        color={color === "light" ? "dark" : "white"}
                        coloredShadow={color}
                        borderRadius="xl"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="4rem"
                        height="4rem"
                        mt={-3}
                    >
                        <Icon fontSize="medium" color="inherit">
                            {icono}
                        </Icon>
                    </MDBox> : <MDBox></MDBox>
                }
                    <MDBox textAlign="right" lineHeight={1.25} mb={1}>
                        {categoria != null && categoria != "" ? <MDTypography variant="h6" fontWeight="light" fontSize={15}>{categoria}</MDTypography> : ""}
                        <MDTypography variant={bigtitulo != null && bigtitulo == true ? "h4" : "h4"} fontWeight="light" color="text" >
                            {searching ? <CircularProgress color="secondary" /> : (titulo != null ? titulo : "-")}
                        </MDTypography>
                        {/*<MDTypography variant="h4">4{count}</MDTypography>                   */}
                    </MDBox>
                </MDBox>
                {children != null && children != "" ? <MDBox>{children}</MDBox> : ""}
            {finalfooter}          
            { btvermas}          
            </Card>
        </MDBox>
    );
}

// Setting default values for the props of ComplexStatisticsCard
OthelloCard.defaultProps = {
    color: "info",
    percentage: {
        color: "success",
        text: "",
        label: "",
    },
};

// Typechecking props for the ComplexStatisticsCard
OthelloCard.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    titulo: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    percentage: PropTypes.shape({
        color: PropTypes.oneOf([
            "primary",
            "secondary",
            "info",
            "success",
            "warning",
            "error",
            "dark",
            "white",
        ]),
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
    }),
    icon: PropTypes.node.isRequired,
};

export default OthelloCard;

/*
 *
//Creamos un componente stateles, ya que no necesitamos nigun estado y son mas rapidos
function OthelloCard({ ...props }) {
    const {
        classes,
        color,
        textoicono,
        categoria,
        titulo,
        footer,
        children,
        bigtitulo,
        smallmode,
        smallfootermode,
        vermas
    } = props;

    //Gestion del icono principal
    let rendericon = props.icono != null ? <div color={color}><props.icono />{textoicono}</div> : "";

    //Gestion del texto que se muestra
    let rendercategoria = <p className={classes.cardCategory}>{categoria}</p>;
    let rendertitulo = bigtitulo != null && bigtitulo == false ? <h4 className={classes.cardIconTitle}>{titulo}</h4> : <h2 className={classes.cardTitle}>{titulo}</h2>;

    //Gestion del header
    let renderheader = smallmode == null || smallmode == false ? <div color={color} stats icon>{rendericon}{rendercategoria}{rendertitulo}</div> : <div color={color} icon>{rendericon}{rendercategoria}{rendertitulo}</div>;

    //Gestion del body
    let renderbody = children != null ? <div>{children}</div> : "";

    //Gestion del footer del card
    let rendericonfooter = props.iconofooter != null ? <props.iconofooter /> : "";
    let btvermas = vermas != null ? <Button size="sm" color="info" component={Link} to={vermas}>Ver mas</Button> : ""

    let renderfooter = <p></p>;

    if (footer != null && footer != "") {
        if (smallfootermode == null || smallfootermode == false)
            renderfooter = <div stats><div className={classes.stats}>{rendericonfooter}{footer}{btvermas}</div></div>;
        else
            renderfooter = <div><div className={classes.stats}>{rendericonfooter}{footer}{btvermas}</div></div>;
    }
    else if (btvermas != null && btvermas != "")
        renderfooter = <div><div>{btvermas}</div></div>;

    return (
        <Card>
            {renderheader}
            {renderbody}
            {renderfooter}
        </Card>
    );
}*/